import { signer } from "theme/colors";
import signerExperienceTokens from "./SignerExperience.tokens";

const { palette, modal, panel } = signerExperienceTokens;

const signerAttachmentTokens = {
  palette,

  dialog: {
    width: modal.width,
  },

  pill: {
    minWidth: 96,
    height: 38,
    radius: "8px",
    paddingX: "12px",
    gap: "7px",
    iconSize: 14,
    fontSize: "12.5px",
    fontWeight: 600,
    background: palette.accentTint,
    emptyBorder: `1.5px solid ${palette.accent}`,
    filledBorder: `1px solid ${palette.accentBorder}`,
    focusRing: `0 0 0 4px ${signer.orange.progressTrack}`,
  },

  dropzone: {
    gap: "12px",
    radius: "8px",
    padding: "13px 14px",
    borderWidth: "1.5px",
    restBorder: palette.accentBorder,
    activeBorder: palette.accent,
    restBackground: palette.white,
    activeBackground: signer.orange.hover,
    disabledOpacity: 0.55,
    iconSize: 26,
    titleFontSize: "13px",
    titleFontWeight: 600,
    metaFontSize: "11.5px",
    metaGap: "2px",
  },

  row: {
    gap: "11px",
    stackGap: "9px",
    paddingY: "10px",
    paddingX: "12px",
    radius: "9px",
    border: `1px solid ${palette.borderLight}`,
    background: palette.white,
    iconTileSize: 32,
    iconTileRadius: "8px",
    iconTileBackground: palette.accentTint,
    iconSize: 17,
    nameFontSize: "13px",
    nameFontWeight: 600,
    metaFontSize: "11.5px",
    metaGap: "2px",
    actionGap: "8px",
    actionButtonSize: 30,
    actionRadius: "7px",
    actionFontSize: "11.5px",
    actionFontWeight: 500,
    actionPaddingX: "12px",
    actionHeight: 30,
    spinnerSize: 16,
    actionSpinnerSize: 14,
    pendingOpacity: 0.75,
    dangerHover: signer.danger.tint,
    renameHeight: 34,
    renameRadius: "7px",
    renameFontSize: "12.5px",
  },

  empty: {
    radius: "9px",
    padding: "22px",
    border: `1px dashed ${palette.border}`,
    fontSize: "12.5px",
    lineHeight: 1.55,
    marginTop: "12px",
  },

  notice: {
    fontSize: "11.5px",
    marginTop: "10px",
  },

  footer: {
    countFontSize: "12px",
  },

  requiredPill: {
    fontSize: "10px",
    fontWeight: 700,
    radius: "999px",
    paddingX: "10px",
    paddingY: "4px",
    background: palette.accentTint,
    color: palette.accentDark,
  },

  preview: {
    canvasBackground: palette.canvas,
    canvasPadding: "26px",
    minHeight: 290,
    /**
     * The viewer fills the window rather than a fixed box — a PDF page at 290px
     * was unreadable. The subtraction covers the modal's own margins, header and
     * footer so the shell never grows past the viewport; the clamp keeps it
     * usable on a short window and stops it stretching on a very tall one.
     */
    viewerHeight: "clamp(320px, calc(100vh - 250px), 820px)",
    sheetWidth: 330,
    sheetRadius: "4px",
    sheetPadding: "26px 28px",
    sheetGap: "9px",
    sheetBorder: `1px solid ${palette.borderLight}`,
    sheetShadow: "0 2px 12px rgba(33, 21, 71, 0.07)",
    lineHeight: 8,
    lineRadius: "3px",
    lineBackground: signer.border.divider,
    lineWidths: ["78%", "94%", "86%"],
    blockHeight: 104,
    blockRadius: "6px",
    blockBorder: `1px dashed ${palette.border}`,
    imageRadius: "6px",
    nameFontSize: "14px",
    nameFontWeight: 700,
    metaFontSize: "11.5px",
  },

  sidePanel: {
    radius: panel.cardRadius,
    padding: panel.cardPadding,
    border: `1px solid ${palette.borderLight}`,
    titleFontSize: "12.5px",
    titleFontWeight: 700,
    countFontSize: "11px",
    rowGap: "8px",
    rowPaddingY: "6px",
    rowIconSize: 13,
    rowNameFontSize: "12px",
    rowMetaFontSize: "11px",
    emptyFontSize: "11.5px",
    emptyLineHeight: 1.5,
  },
};

export default signerAttachmentTokens;
